// extracted by mini-css-extract-plugin
export default {"image":"style_image__Tbdcw"};